export const MIN_PIN_LENGTH = 4;
export const DEFAULT_LANGUAGE = 'en';
export const HOME_WEBSITE = 'https://m2u.money';
export const LOGIN_RETURN_URL = 'next';
export const COMPANY_NAME = 'Ossix Technologies LLC';
export const APP_NAME = 'M2U Money';
export const PEER_SERVICES_OG_IMAGE_URL =
  'https://www.app.m2u.money/marketplace';
export const PEER_SERVICES_OG_URL =
  'https://www.app.m2u.money/marketplace';
export const PRIVACY_POLICY_URL = 'https://m2u.money/privacy-policy';

export const TERMS_AND_CONDITIONS_URL =
  'https://m2u.money/terms-and-conditions/';

// contact blocking status

export const BLOCKED_ME = 'BLOCKED_ME';
export const UNBLOCKED_ME = 'UNBLOCKED_ME';

// chat threads and direct messages
export const PAGINATION_ITEMS_PER_PAGE = 20;

// chat message types
export const SENT = 'sent';
export const SEEN = 'seen';
export const DELIVERED = 'delivered';
export const SENDING = 'sending';

// Delete message options
export const DELETE_FOR_ME = 'deleteForMe';
export const DELETE_FOR_ALL = 'deleteForAll';

// chat types
export const ONE_TO_ONE = 'ONE_TO_ONE';
export const GROUP = 'GROUP';

// user presence statuses

export const ONLINE = '0';
export const AWAY = '1';
export const DO_NOT_DISTURB = '2';
export const INVISIBLE = '3';
export const OFFLINE = '4';

// Money transfer target types

export const CELINE_MONEY = '1';
export const DEBIT_CARD = '3';
export const BANK_TRANSFER = '4';
export const PAYPAL = '7';
export const CASH_OUT = '9';
export const SUPPLIERS_PAY_BILLS = '10';
export const VIRTUAL_CARD = '11';
export const CASH_POINT_INCOME = '12';
export const SAVINGS = '13';
export const CARDLESS_ATM = '14';
export const BUS_TICKER = '15';
export const ELECTRICITY_AND_WATER = '17';
export const INSURANCE_FEES = '18';
export const WARI = '19';
export const INTOUCH = '20';
export const TELCO = '21';
export const MERCHANT = '24';

//  REPORT ABUSE ITEM TYPES

export const REPORT_SERVICE = '1';
export const REPORT_SERVICE_COMMENT = '2';
export const REPORT_STORE_COMMENT = '3';
export const REPORT_CHAT_CONVERSATION = '4';

// PEER SERVICES FILE OPERATIONS
export const DELETE_FILE = 'D';
export const CREATE_FILE = 'C';
export const UPDATE_FILE = 'U';

// PEER SERVICES MEDIA TYPES
export const PEER_SERVICE_IMAGE = '1';
export const PEER_SERVICE_VIDEO = '3';
export const PEER_SERVICE_AUDIO = '2';

// PEER SERVICES BOOK MARK OPTIONS

export const ADD_TO_BOOKMARKS = 'Add';
export const REMOVE_FROM_BOOKMARKS = 'Remove';

// HOW IT WORKS

export const HOW_IT_WORKS = 'https://m2u.money/how-it-works';
export const TERMS_CONDITIONS =
  'https://m2u.money/terms-and-conditions';
export const PRIVACY_POLICY = 'https://m2u.money/privacy-policy';

// KYC ID types
export const idID = '1';
export const idPassport = '2';
export const idDriverLicence = '3';
export const idOther = '4';

export const bankAccountOptions = {
  APPROVE: 1,
  REJECT: 2,
  UNLINK: 3,
  FREEZE: 4,
  UNFREEZE: 5,
};

// STORE

export const ACTIVE_STORE = '1';
export const SUSPENDED_STORE = '2';
export const AppVersion = '1';
export const storageKeyName = 'browser-unique-signature';
export const OTP_PAGE_ID = 'opt-page-id';
export const OTP_PAGE_REFRESHED_ID = 'opt-page-refreshed-id';
